define(['jquery'], function ($) {
	return {
		MaskingCPRNumber: function (input) {

			const value = input.value.replace(/\D/g, '');
			if (value.length > 6) {
				input.value = value.slice(0, 6) + '-' + value.slice(6, 10);
			}
			else {
				input.value = value;
			}
		},

		MaskingCVRNumber: function (input, domain) {

			const value = input.value.replace(/\D/g, '');
			domain = domain.toLowerCase();
			if (domain === 'dk') {
				input.maxLength = 8;
				input.value = value;
			}
			else if (domain === 'se') {
				input.maxLength = 11;
				if (value.length > 6) {
					input.value = value.slice(0, 6) + '-' + value.slice(6, 10);
				}
				else {
					input.value = value;
				}
			}
		}
	};
});